<section class="bg-deep">
  <div class="logo mb-4">
    <img src="./assets/images/brand_white.png" alt="Union Solutions">
  </div>
  <div class="card">
    <div class="card-body py-4 d-flex flex-column justify-content-between">
      <!-- Etapa 1: Entrada de Login -->
      <div *ngIf="etapa === 1">
        <label class="fw-500 mb-2" for="login">Informe seu login</label>
        <input [formControl]="form.controls['login']" id="login" placeholder="Digite seu login" type="text"
          class="form-control" />
        <app-msg-erro [control]="form.controls['login']"></app-msg-erro>
        <button (click)="proximaEtapa()" class="btn btn-success mt-4 w-100">Próximo</button>
      </div>

      <!-- Etapa 2: Entrada de Email -->
      <div *ngIf="etapa === 2">
        <label class="fw-500 mb-2" for="email">
          Informe o e-mail cadastrado
        </label>
        <input [formControl]="form.controls['email']" id="email" placeholder="Digite seu e-mail" type="email"
          class="form-control" />
        <app-msg-erro [control]="form.controls['email']"></app-msg-erro>
        <div class="text-muted mt-2">
          <small>Email: {{ emailMascarado }}</small>
        </div>
        <button (click)="proximaEtapa()" class="btn btn-success mt-4 w-100">Recuperar</button>
        <button (click)="voltarEtapa()" class="btn btn-secondary mt-2 w-100">Voltar</button>
      </div>

      <!-- Link para voltar ao login -->
      <a [routerLink]="'/login'" class="btn fw-500 mt-4 btn-outline-primary btn-icon w-100 border-0">
        <i class="mdi mdi-arrow-left mr-2"></i>
        <span>Efetuar login</span>
      </a>
    </div>
  </div>
</section>